import { render } from "./BeneVoles.vue?vue&type=template&id=618db905&scoped=true&ts=true"
import script from "./BeneVoles.vue?vue&type=script&lang=ts"
export * from "./BeneVoles.vue?vue&type=script&lang=ts"

import "./BeneVoles.vue?vue&type=style&index=0&id=618db905&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618db905"]])

export default __exports__